import { init as srfAnalytics } from '@aron/common/analytics/init.js';
import { init as deadmansSwitchInit } from '@aron/common/analytics/Deadman.js';

import { init as transInit } from '@fec/assets/js/utils/trans.js';
import { init as a11yInit } from '@fec/frontend/foundation/a11y.js';

import { init as subnavInit } from '@fec/frontend/modules/groups-and-lists/subnav/subnav.js';

import '@fec/frontend/foundation/utils/easings.js';
import '@fec/frontend/modules/containers/modal/modal.js';

import { init as popupInit } from '@fec/frontend/foundation/popup/popup.js';
import { init as imageNgInit } from '@fec/frontend/elements/media/image-ng/image-ng.js';
import { init as searchInit } from '@fec/frontend/elements/search/search/search.js';
import { init as srfSearchInit } from '@aron/common/search/srf-search.js';
import { init as flyingFocusInit } from '@fec/frontend/foundation/flying-focus.js';
import { init as teaserInfoUpdaterInit } from '@fec/frontend/elements/text/teaser-info/teaser-info-updater.js';
import { init as srfMeteoLazyloadInit } from '@default/webview/js/srf-meteo-lazyload.js';
import { init as showDetailsInit } from '@fec/frontend/modules/content/show-detail/show-detail.js';
import { init as srfSongLog } from '@fec/frontend/modules/groups-and-lists/songlog/songlog.js';
import { init as srfThemeColorInit } from '@aron/common/srf-themeColor.js';
import { init as teaserLabelInit } from '@fec/frontend/elements/text/teaser-label/teaser-label.js';
import { init as radioActionBarInit } from '@fec/frontend/snowflakes/radio/radio-action-bar/radio-action-bar.js';
import { init as modalInit } from '@fec/frontend/modules/containers/modal/modal.js';
import { init as SwipeableAreaInit } from '@fec/frontend/modules/containers/swipeable-area/swipeable-area.js';
import { init as swipeableControlInit } from '@fec/frontend/modules/collections/collection-ng/collection-ng-swipeable.js';
import { init as srfMediaProgressDisplayInit } from '@fec/frontend/elements/media/media-progress-bar/media-progress-bar.js';
import { init as srfShareModalInit } from '@aron/common/srf-share-modal.js';
import { init as consentManagerInit } from '@aron/common/consent/consentManager.js';
import { init as embedConsentHandlerInit } from '@fec/frontend/modules/content/embed/embedConsentHandler.js';

import '@aron/common/srf-touch-fix.js';

// self initialising components
import * as pluginLoader from '@aron/plugin-loader.js';

import.meta.glob([
  '../../frontend-components/assets/img/**',
  '../../legacy/meteo/img/**',
  '../../../public/static-assets/images/**',
]);

/**
 * Common Assets
 */

/**
 * Analytics
 */
export function analytics() {
  consentManagerInit();
  srfAnalytics();
  srfSearchInit();
  deadmansSwitchInit();
}

/**
 * Navigation
 */
export function navigation() {
  searchInit();
  subnavInit();
}

/**
 * Basic
 */
export function base() {
  pluginLoader.init('web');
  transInit();
  a11yInit();
  embedConsentHandlerInit();
  flyingFocusInit();
  popupInit();
  imageNgInit();
  teaserInfoUpdaterInit();
  srfMeteoLazyloadInit();
  showDetailsInit();
  radioActionBarInit();
  modalInit();
  srfSongLog();
  srfThemeColorInit();
  teaserLabelInit();
  SwipeableAreaInit();
  swipeableControlInit();
  srfMediaProgressDisplayInit();
  srfShareModalInit();
}

/**
 * Common Web JS
 */
export function commonWeb() {
  analytics();
  navigation();
  base();
}
